import cn from 'classnames';
import React from 'react';

import './Input.css';

interface Props extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'onChange'
> {
    onChange: (value: string) => void;
    error?: string;
}

export const Input: React.FC<Props> = ({ error, onChange, className, ...props }) => (
  <div className="Input-container">
      <input
        {...props}
        onChange={(event) => onChange(event.target.value)}
        className={cn('Input', className)}
      />
      {error && <span className="Input-error">{error}</span>}
  </div>
);
